/* eslint-disable @typescript-eslint/naming-convention */
import {
  CrudFormConfig,
  CrudViewFormItemType,
  CrudFormTextBoxItem,
  TextBoxType,
  FormLayout,
  CrudFormInputValidatorInfoItem,
  InputSize,
  ButtonType,
  FeedbackComponentConfig,
  FeedbackButtonActionBehavior,
  ButtonSize,
  IconType
} from '@rappider/rappider-components/utils';
import { PASSWORD_REGEX, SPECIAL_CHARACTER_REGEX } from '../../definitions/regex';
import { Validators } from '@angular/forms';
import { PATH_DEFINITIONS } from '../../definitions/path-definition';
import { CrudFormInputGroupItem } from 'libs/components/src/lib/utils/edit-form/crud-form-input-group-item.interface';

export const PHONE_NUMBER_VERIFY_FAILURE_CONFIG: FeedbackComponentConfig = {
  icon: {
    name: 'fas fa-exclamation-triangle text-danger'
  },
  title: 'AUTHENTICATION_MODULE.PHONE_NUMBER_VERIFY_COMPONENT.VERIFY_PHONE_NUMBER_FAILURE_TITLE',
  subTitle: 'AUTHENTICATION_MODULE.PHONE_NUMBER_VERIFY_COMPONENT.VERIFY_PHONE_NUMBER_FAILURE_DESCRIPTION',
  buttons: [
    {
      content: 'AUTHENTICATION_MODULE.PHONE_NUMBER_VERIFY_COMPONENT.CLICK_HERE_RESEND_VERIFY_SMS',
      type: ButtonType.Primary,
      actionBehavior: FeedbackButtonActionBehavior.Emit
    }
  ]
};

export const PHONE_NUMBER_VERIFY_SUCCESS_CONFIG: FeedbackComponentConfig = {
  icon: {
    name: 'far fa-check-circle text-success'
  },
  title: 'AUTHENTICATION_MODULE.PHONE_NUMBER_VERIFY_COMPONENT.VERIFY_PHONE_NUMBER_SUCCESS_TITLE',
  subTitle: 'AUTHENTICATION_MODULE.PHONE_NUMBER_VERIFY_COMPONENT.VERIFY_PHONE_NUMBER_SUCCESS_DESCRIPTION',
  buttons: [
    {
      content: 'SHARED.GO_TO_HOME_PAGE',
      type: ButtonType.Primary,
      actionBehavior: FeedbackButtonActionBehavior.Route,
      redirectUrl: PATH_DEFINITIONS.PROJECTS.PROJECT_LIST_PATH
    }
  ]
};

export const REGISTER_CONFIG: CrudFormConfig = {
  items: [
    <CrudFormTextBoxItem>{
      title: 'SHARED.FIRST_NAME',
      fieldName: 'firstName',
      type: CrudViewFormItemType.TextBox,
      index: 1,
      disabled: false,
      size: InputSize.Default,
      placeholder: 'SHARED.FIRST_NAME',
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ],
      columnWidth: 50
    },
    <CrudFormTextBoxItem>{
      title: 'SHARED.LAST_NAME',
      fieldName: 'lastName',
      index: 2,
      type: CrudViewFormItemType.TextBox,
      size: InputSize.Default,
      placeholder: 'SHARED.LAST_NAME',
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        }
      ],
      columnWidth: 50
    },
    <CrudFormTextBoxItem>{
      title: 'SHARED.EMAIL',
      fieldName: 'email',
      type: CrudViewFormItemType.TextBox,
      required: true,
      index: 3,
      textType: TextBoxType.Email,
      autoComplete: 'new-password',
      size: InputSize.Default,
      placeholder: 'SHARED.EMAIL',
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        },
        {
          type: Validators.email,
          errorKey: 'email',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.VALID_EMAIL_MESSAGE'
        }
      ]
    },
    <CrudFormInputGroupItem>{
      title: 'SHARED.PASSWORD',
      fieldName: 'password',
      type: CrudViewFormItemType.InputGroup,
      textbox: {
        type: TextBoxType.Password,
        placeholder: 'SHARED.PASSWORD'
      },
      autoComplete: 'new-password',
      placeholder: 'SHARED.PASSWORD',
      suffixIcon: {
        name: 'eye',
        type: IconType.NgZorro,
        isClickable: true
      },
      index: 4,
      size: InputSize.Default,
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        },
        {
          type: Validators.pattern(PASSWORD_REGEX),
          errorKey: 'pattern'
        }
      ],
      columnWidth: 50
    },
    <CrudFormInputGroupItem>{
      title: 'SHARED.CONFIRM_PASSWORD',
      fieldName: 'confirmPassword',
      type: CrudViewFormItemType.InputGroup,
      textbox: {
        type: TextBoxType.Password,
        placeholder: 'SHARED.PASSWORD'
      },
      autoComplete: 'new-password',
      suffixIcon: {
        name: 'eye',
        type: IconType.NgZorro,
        isClickable: true
      },
      index: 5,
      size: InputSize.Default,
      placeholder: 'SHARED.CONFIRM_PASSWORD',
      validators: [
        {
          type: Validators.required,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.REQUIRED_FIELD_MESSAGE'
        },
        {
          errorKey: 'mustMatch',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.MUST_MATCH_PASSWORD'
        }
      ],
      columnWidth: 50
    },
    <CrudFormInputValidatorInfoItem>{
      relatedFieldName: 'password',
      type: CrudViewFormItemType.InputValidatorInfo,
      index: 6,
      patternInfos: [
        {
          pattern: /[1-9]/,
          message: 'ERRORS.PATTERN_MESSAGES.PASSWORD_PATTERN_MESSAGES.ONE_DIGIT'
        },
        {
          pattern: /[A-Z]/,
          message: 'ERRORS.PATTERN_MESSAGES.PASSWORD_PATTERN_MESSAGES.ONE_UPPERCASE'
        },
        {
          pattern: SPECIAL_CHARACTER_REGEX,
          message: 'ERRORS.PATTERN_MESSAGES.PASSWORD_PATTERN_MESSAGES.SPECIAL_CHARACTER'
        },
        {
          pattern: /.{8,}/,
          message: 'ERRORS.PATTERN_MESSAGES.PASSWORD_PATTERN_MESSAGES.MINIMUM_LENGTH'
        }
      ],
    },
    <CrudFormTextBoxItem>{
      text: {
        text: 'SHARED.RAPPIDER_TERMS'
      },
      title: null,
      fieldName: 'privacyPolicy',
      type: CrudViewFormItemType.CheckBox,
      showRequiredSign: false,
      validators: [
        {
          type: Validators.requiredTrue,
          errorKey: 'required',
          errorMessage: 'ERRORS.PATTERN_MESSAGES.RAPPIDER_TERM_CHECKBOX_MESSAGE'
        }
      ]
    }
  ],
  validators: [
    {
      name: 'MustMatch',
      validatorKey: 'mustMatch',
      params: {
        field1: 'password',
        field2: 'confirmPassword'
      }
    }
  ],
  itemSettings: {
    inputComponentSize: {
      xs: 24
    },
    labelComponentSize: {
      xs: 24
    }
  },
  submitButton: {
    text: 'AUTHENTICATION_MODULE.SIGN_UP',
    size: ButtonSize.Default,
    block: true,
    type: ButtonType.Primary
  },
  formLayout: FormLayout.Vertical
};
